import { UploadCareImageVariant } from "@mallardbay/lib-react-components"
import React from "react"

import ImageCard from "~components/shared/todo-lib-react-components/image-card/image-card"
import type { SpeciesFieldsFragment } from "~graphql/generated/graphql"

interface Props {
    readonly species: SpeciesFieldsFragment
}

export default function SpeciesImageCard({ species }: Props) {
    return (
        <ImageCard
            title={species.name}
            headerImageSrc={species.image?.url}
            headerImageAlt={species.name}
            uploadCareImageVariant={UploadCareImageVariant.SM_HORIZONTAL}
        />
    )
}
